import type { Event } from '@patsnap/tahiti-core';
import type { FeatureLocatedState, GetClaimCompareMatchParams, GetResultPositionParams } from '../types';

export const FeatureLocatedService = Symbol.for('FeatureLocatedService');

export interface FeatureLocatedService {
    readonly onStatesChange: Event<FeatureLocatedState>;
    getModelData(): FeatureLocatedState;
    updateModelData(data: Partial<FeatureLocatedState>): void;

    // ============ V1 方法（保留向后兼容） ============
    setLocatedPatentInfo({ patentId, text }: { patentId: string; text: string; }): void;
    getFeatureMatchData(params: GetClaimCompareMatchParams): Promise<void>;

    // ============ V2 方法 ============
    getFeatureMatchDataV2(params: GetResultPositionParams): Promise<void>;

    // ============ 通用方法（V1/V2 共用） ============
    markFeatureInDocument(wrapperClass?: string): void;
    scrollToNode(number: number): void;
}
